import { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Header from './components/Header';
import Footer from './components/Footer';
import ContactDialog from './components/ContactDialog';
import StickyContactButton from './components/StickyContactButton';
import ErrorBoundary from './components/ErrorBoundary';
import HomePage from './pages/HomePage';
import ServicesPage from './pages/ServicesPage';
import KnowledgeBasePage from './pages/KnowledgeBasePage';
import AboutPage from './pages/AboutPage';
import NotFoundPage from './pages/NotFoundPage';
import ImpressumPage from './pages/ImpressumPage';
import DatenschutzPage from './pages/DatenschutzPage';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function AppLayout() {
  const [contactOpen, setContactOpen] = useState(false);

  return (
    <div className="min-h-screen flex flex-col bg-ak-navy">
      <ScrollToTop />
      <Header onContactClick={() => setContactOpen(true)} />
      <main className="flex-grow">
        <ErrorBoundary>
          <Routes>
            <Route path="/" element={<HomePage onContactClick={() => setContactOpen(true)} />} />
            <Route path="/leistungen" element={<ServicesPage onContactClick={() => setContactOpen(true)} />} />
            <Route path="/wissen" element={<KnowledgeBasePage onContactClick={() => setContactOpen(true)} />} />
            <Route path="/ueber-mich" element={<AboutPage />} />
            <Route path="/impressum" element={<ImpressumPage />} />
            <Route path="/datenschutz" element={<DatenschutzPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </ErrorBoundary>
      </main>
      <Footer onContactClick={() => setContactOpen(true)} />
      <StickyContactButton onContactClick={() => setContactOpen(true)} />
      <ContactDialog isOpen={contactOpen} onClose={() => setContactOpen(false)} />
    </div>
  );
}

function App() {
  return (
    <HelmetProvider>
      <Router>
        <AppLayout />
      </Router>
    </HelmetProvider>
  );
}

export default App;
